import React from 'react';
import CustomPage from 'src/components/CustomPage';

const FAQ: React.FC = () => {
  return <CustomPage pageType="faq" pageName="FAQ" />;
};

export default FAQ;
